module.exports = __webpack_public_path__ + "static/img/wise.60b72ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wise.png
// module id = 1ag5
// module chunks = 1